module.exports = __webpack_public_path__ + "media/images/presta_busc/enfermero-a2300bb6fddc8f48e898bf836a57046c.svg";